/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
    $(function () {
      $(".c-forms-simple__file input").on('change', function () {
        var file = $(this).prop('files')[0];
        var label = $(this).parent().parent().find("label");

        if (!($(this).children(".filename").length)) {
          $(this).parents(".c-forms-simple__file").append('<span class="filename"></span>');
          label.addClass('changed');
        }

        if(file === undefined){
          label.removeClass('changed');
          $(this).parents(".c-forms-simple__file").find(".filename").html("");
        }else {
          $(this).parents(".c-forms-simple__file").find(".filename").html(file.name);
        }
      });
    });

  }

  $(function () {
    var app = new growApp();
    app.myCode();
  });
})(jQuery);
